import { FC } from 'react';

interface Props {
  onExport: () => void;
  /** Habilita só quando já existe uma revisão na conversa pra exportar. */
  disabled?: boolean;
}

/**
 * Botão "Exportar devolutiva" (Frente 7, Q06). Dispara o `export_review_report` (Q05)
 * via mensagem do chat — o backend lê a `review` já persistida e devolve o .docx (chip
 * de download). Fica desabilitado enquanto não há revisão pra exportar.
 */
const ReviewExportButton: FC<Props> = ({ onExport, disabled }) => (
  <button
    type="button"
    data-testid="review-export-button"
    onClick={onExport}
    disabled={disabled}
    title={
      disabled
        ? 'Revise um documento antes de exportar a devolutiva'
        : 'Exportar a devolutiva (.docx) com os apontamentos da revisão'
    }
    className="inline-flex items-center gap-1.5 text-xs px-3 py-1.5 rounded-lg bg-accent text-surface-primary font-semibold hover:opacity-90 transition disabled:opacity-40 disabled:cursor-not-allowed"
  >
    <span className="material-symbols-outlined text-base leading-none">description</span>
    Exportar devolutiva
  </button>
);

export default ReviewExportButton;
